import { PureComponent } from 'react';
import { isEmpty } from 'lodash';
import { logEvent, setUserProperties, setUserId } from 'firebase/analytics';
import { AnalyticsEvents } from '@sda/interfaces/queue/analytics';
import { Facebook } from './Analytics/Facebook';
import { Kissmetrics } from './Analytics/Kissmetrics';
import { Intercom } from './Analytics/Intercom';
import { AnalyticsLoader } from './Analytics/AnalyticsLoader';

/**
 * Analytics controller class to handle all tracked events
 */
export class Analytics extends PureComponent {
  static Instance;

  /**
   * Set the identity of a user
   * @params user
   */
  static setIdentity = (user) => {
    if (!isEmpty(user)) {
      Kissmetrics.push(['identify', user.originalEmailAddress || user.uid]);

      if (user.originalEmailAddress) {
        Kissmetrics.push(['alias', user.uid, user.originalEmailAddress]);
      }

      if (window?.Analytics) {
        setUserId(window.Analytics, user.uid);
      }
    }
  };

  /**
   * Push properties to user in analytics provider
   * @params data
   */
  static updateUser = (user, profile = null) => {
    Intercom.identify(user, profile);

    Kissmetrics.push(['set', user]);

    if (window?.Analytics) {
      setUserProperties(window.Analytics, user);
    }
  };

  static clearIdentity = (identity = null) => {
    Kissmetrics.push(['clearIdentity', identity]);
  };

  /**
   * Send some action as an analytics event
   * @params action
   * @params data
   */
  static track = (action, data = null) => {
    if (action) {
      // process data to send with events, excluding page view events
      // remove props details if user has not accepted cookie tracking or is falsey
      let props;

      if (action === AnalyticsEvents.VIEWED_PAGE) {
        props = data;
      } else {
        props = (Analytics.Instance && Analytics.Instance.state.acceptsCookies)
          ? Analytics.appendCurrentPath(data)
          : null;
      }

      // send to analytics providers
      Intercom.trigger(action, props);
      Kissmetrics.push(['record', action, props]);

      if (window && window.fbq) {
        Facebook.push(action, props);
      }

      if (window?.Analytics) {
        logEvent(window.Analytics, action.toLowerCase(), props);
      }
    }
  };

  /**
   * Appends current path to an event
   * @param {object} data
   */
  static appendCurrentPath = (data) => {
    const { pathname } = new URL(window.location);

    if (data) {
      return { currentPath: pathname, ...data };
    }
    return { currentPath: pathname };
  };

  static setAcceptsCookies = (acceptsCookies) => {
    if (Analytics.Instance) {
      Analytics.Instance.setState({ acceptsCookies });
    } else {
      console.log('No Analytics Instance');
    }
  };

  constructor(props) {
    super(props);

    this.state = {
      acceptsCookies: undefined,
    };

    Analytics.Instance = this;
  }

  render() {
    const { acceptsCookies } = this.state;

    return (
      <AnalyticsLoader acceptsCookies={acceptsCookies} />
    );
  }
}
